import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Checkbox } from "antd";
import { EmailIcon, LockIcon } from "assets/icons";
import { getIn, useFormik } from "formik";
import md5 from "md5";
import moment from "moment";
import { doVerifyEmail } from "stores/slices/auth";
import { YupValidations } from "utils/validation";
import * as Yup from "yup";

import AppButton from "components/button";

import FormInput from "./components/formInput";

const signUpForm = props => {
  const { onSubmit, loading, setIsAgreeTermsOfService, isAgreeTermsOfService } =
    props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const validationSchema = Yup.object().shape({
    email: YupValidations.email,
    password: YupValidations.password,
    confirmPassword: YupValidations.confirmPassword,
  });

  const handleAgreeTermsOfService = e => {
    setIsAgreeTermsOfService(e.target.checked);
  };

  const onSubmitForm = async data => {
    const { payload } = await dispatch(
      doVerifyEmail({ email: data.email.trim() })
    );
    if (payload && payload.status === 200 && payload.data) {
      onSubmit &&
        onSubmit({
          ...data,
          email: data.email.trim(),
          password: md5(data.password),
          confirmPassword: md5(data.confirmPassword),
          timeZone: moment.tz.guess(),
        });
    } else {
      toast.error(t("validate.email.invalid"));
    }
  };

  const signUpForm = useFormik({
    initialValues: {
      email: "",
      password: "",
      confirmPassword: "",
      timeZone: "",
    },
    validationSchema: validationSchema,
    onSubmit: onSubmitForm,
  });

  const { values, setFieldValue, handleSubmit, errors } = signUpForm;

  useEffect(() => {
    console.log("errors", errors);
  }, [errors]);

  useEffect(() => {
    const keyDownHandler = event => {
      if (event.key === "Enter") {
        event.preventDefault();

        handleSubmit();
      }
    };

    document.addEventListener("keydown", keyDownHandler);

    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [values]);

  const inputItems = [
    {
      type: "text",
      key: "email",
      value: "",
      placeholder: "label.placEmail",
      icon: <EmailIcon />,
      span: 24,
      size: "midlle",
      style: {
        paddingBottom: 4,
      },
    },
    {
      type: "password",
      key: "password",
      value: "",
      placeholder: "label.placPassword",
      icon: <LockIcon />,
      span: 24,
      style: {
        paddingBottom: 4,
      },
    },
    {
      type: "password",
      key: "confirmPassword",
      value: "",
      placeholder: "label.placConfirmPassword",
      icon: <LockIcon />,
      span: 24,
      style: {
        paddingBottom: 4,
      },
    },
  ];

  return (
    <div>
      <FormInput
        items={inputItems.map(item => {
          item.label = t(item.label);
          if (item.key) {
            item.value = getIn(values, item.key);
          }
          return { ...item };
        })}
        form={signUpForm}
        onChange={setFieldValue}
      />
      <div style={{ marginBottom: 12 }}>
        <Checkbox onChange={handleAgreeTermsOfService}>
          {t("signUp.agreeTermOfService")}
        </Checkbox>
        <a
          target="_blank"
          href="https://messageclub.com/term-of-service.html"
          rel="noreferrer"
          style={{
            marginRight: 8,
            fontSize: 14,
            fontWeight: 500,
            color: "#5162F3",
          }}
        >
          {t("signUp.termOfService")}
        </a>
      </div>
      <AppButton
        label={t("label.signUp")}
        color={"primary"}
        disabled={!isAgreeTermsOfService}
        loading={loading}
        type="submit"
        onClick={handleSubmit}
        className="authButton"
      />
    </div>
  );
};

export default signUpForm;
